import { render, staticRenderFns } from "./MerchantPayoutMethods.vue?vue&type=template&id=b35ddb72"
import script from "./MerchantPayoutMethods.vue?vue&type=script&lang=js"
export * from "./MerchantPayoutMethods.vue?vue&type=script&lang=js"
import style0 from "./MerchantPayoutMethods.vue?vue&type=style&index=0&id=b35ddb72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports